module.exports = __webpack_public_path__ + "static/img/06004B_1_R_20230325_fit.c8477e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/06004B_1_R_20230325_fit.png
// module id = EA8m
// module chunks = 0